import { useEffect } from 'react';

import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeFeatureFlag } from '@/utils/amplitude/experiments/utils/useAmplitudeExperiments';

export function useSearchInputRedesignExperiment(): boolean;
export function useSearchInputRedesignExperiment(options: { expose: false }): {
    isShowingFeature: boolean;
    trackFeatureFlag: () => void;
};
export function useSearchInputRedesignExperiment(options?: {
    expose?: boolean;
}): boolean | { isShowingFeature: boolean; trackFeatureFlag: () => void } {
    const { isShowingFeature, trackFeatureFlag } = useAmplitudeFeatureFlag(
        AmplitudeExperiments.SearchInputRedesignExperiment,
        AmplitudeVariants.SearchInputRedesignExperiment.Treatment
    );

    const shouldAutoExpose = options?.expose !== false;

    useEffect(() => {
        if (shouldAutoExpose) {
            return trackFeatureFlag();
        }
    }, [isShowingFeature, shouldAutoExpose, trackFeatureFlag]);

    if (!shouldAutoExpose) {
        return { isShowingFeature, trackFeatureFlag };
    }

    return isShowingFeature;
}
